//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import role from "apis/role/role";
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryTable from "components/Table/History/HistoryTable";
import { toast } from "react-toastify";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import benefitcode from "apis/BenefitCode/benefitcode";
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";

export default function BenefitCode(props) {
  const { state, dispatch } = useContext(context);
  const { getBenefitCode,exports } = benefitcode();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const [exportData, setExportData] = useState([]);
  
  const [isActive, setIsActive] = useState(true);
  const { t, i18n } = useTranslation();
  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "BENEFITCODE"] });
  }, []);

  const [states, setstates] = useState({ historyLoader: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset, isActive]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20
      };
      let res = await getBenefitCode(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };

  const handleExport = async () => {
    let values = {};
    // let values = {};
   
    // setLoading(true)
    

    dispatch({ type: "SET_LOADING", payload: true });
    let res = await exports(values);
    console.log(res,"ragav")
    if (res && res.data) {
        // setIsLoading(false);
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
       
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return false;
        }
       
        return true;
      }
    }

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
          <Button
            className={`${classes.createBtn} dash-1-filter-btn`}
            onClick={() => {
              history.push("/dashboard/create-benefit-code");
            }}
          >
            {'Create'}
          </Button>
          <CSVLink
            id="csv"
            data={exportData.map(item => ({
              ...item,
              default: item.default ? "Yes" : "No"
            }))}
             headers={exportHeaders}
         filename={
              `Benefit-Code` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
        </Grid>
        
      </Grid>
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            {res ? (
              <Table
                headings={[
                  "Id",
                  "Tier",
                  "Privilege Type",
                  "Privilege Code",
                  "Default",
                  "Default_Assign",
                  "Operation"
                ]}
                data={
                  data &&
                  data.length > 0 &&
                  data.map((d, i) => [
                    d?.id !== null ?(d?.id): ('-'),
                    d?.tier !== null ?(d?.tier ):('-'),
                    d?.privilege_type !== null ?(d?.privilege_type ):('-'),
                    d?.privilege_code !== null ?(d?.privilege_code):('-'),
                    d?.default ?(
                      <span style={{ color: "green" }}>Yes</span>
                    ):(
                      <span style={{ color: "red" }}>No</span>
                    ),
                    d?.default_assign ?(
                      <span style={{ color: "green" }}>Yes</span>
                    ):(
                      <span style={{ color: "red" }}>No</span>
                    ),
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/view-benefit-code", { data: d });
                      }}
                    >
                      <VisibilityIcon />
                    </div>
                  ])
                }
                offset={offset}
                count={
                  (count / 20) % 1 == 0
                    ? Math.floor(count / 20)
                    : Math.floor(count / 20 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
          </Grid>
        </Grid>
      </Loader>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {'History'}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}` : "",
                  `${d?.["User.email"] ? d?.["User.email"] : d?.altered_by ? d?.altered_by.charAt(0).toUpperCase() + d?.altered_by.slice(1).toLowerCase() : "-"}`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
